import type { TFunction } from "i18next";

/**
 * name_formula を解析して翻訳済み文字列を返す
 *
 * 合成式の形式:
 *   - 単一キー:  "HOME"           → t("HOME")
 *   - 複合キー:  "EMPLOYEE+SETTINGS" → t("EMPLOYEE") + t("SETTINGS")
 *
 * name_formula が null/空の場合は fallback（name カラムの値）を返す
 */
export function resolveFormula(
    formula: string | null,
    t: TFunction,
    fallback: string,
): string {
    if (!formula) return fallback;

    return formula
        .split("+")
        .map((key) => t(key.trim()))
        .join("");
}
